import { BranchConstants } from 'src/constants';

function checkIsStringArray(items) {
  return items.every(function (item) {
    return typeof item === 'string';
  });
}

var DEFAULT_SERVICE_DURATION = 30;
export var getServiceNameList = function getServiceNameList() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BranchConstants;
  return checkIsStringArray(config.SERVICE_NAME_LIST) ? config.SERVICE_NAME_LIST : config.SERVICE_NAME_LIST.map(function (data) {
    return data.name;
  });
};
export var getServiceDuration = function getServiceDuration(serviceName) {
  var _config$SERVICE_NAME_, _config$SERVICE_NAME_2;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BranchConstants;
  return checkIsStringArray(config.SERVICE_NAME_LIST) ? DEFAULT_SERVICE_DURATION : (_config$SERVICE_NAME_ = (_config$SERVICE_NAME_2 = config.SERVICE_NAME_LIST.find(function (_ref) {
    var name = _ref.name;
    return name === serviceName;
  })) === null || _config$SERVICE_NAME_2 === void 0 ? void 0 : _config$SERVICE_NAME_2.duration) !== null && _config$SERVICE_NAME_ !== void 0 ? _config$SERVICE_NAME_ : DEFAULT_SERVICE_DURATION;
};